import React from 'react'
import { Box, Typography } from '@mui/material'
import logoplant from '../assets/icons/logoplant.png' // Adjust the path to your logo image
const HeroBanner = () => {
  return (
    <Box
      sx={{
        mt: { lg: '212px', xs: '40px' },
        ml: { sm: '50px' },
        display: 'flex',
        flexDirection: { xs: 'column-reverse', lg: 'row-reverse' },
        justifyContent: { lg: 'center', xl: 'center', md: 'center', xs: 'right' }, // Center content horizontally on large screens
        textAlign: { md: 'center', lg: 'center', xs: 'right', xl: 'center' }, // Center text on large screens, keep right-align for small screens
      }}
      position="relative"
      p="20px"
      dir="rtl" // Ensures RTL layout for text
    >
      {/* Text Section */}
      <Box sx={{
        flex: 1, textAlign: { lg: 'center', xs: 'right', xl: 'center', md: 'center' }, // Center text on large screens
      }}>
        {/* <img src={logoplant} alt="logo2" width="150px" ></img> */}
        <Typography fontWeight={700} sx={{ fontFamily: 'GveretLevin', fontSize: { lg: '60px', xs: '24px', md: '34px', xl: '80px' } }} mt="30px">
          להתאמן, להנות
        </Typography>
        <Typography fontWeight={700} sx={{ fontFamily: 'GveretLevin', fontSize: { lg: '60px', xs: '24px', md: '34px', xl: '80px' } }} mb="23px" mt="5px">
          כל יום מחדש

        </Typography>
        <Typography fontSize="22px" fontFamily="GveretLevin" lineHeight="35px">
          חפש את התרגילים
        </Typography>
        <Typography fontSize="22px" fontFamily="GveretLevin" mb="23px" lineHeight="35px">
          הכי רלוונטים עבורך
        </Typography>
        <a href="#exercises" width="500px" style={{ fontFamily: 'GveretLevin', marginTop: '45px', textDecoration: 'none', width: '30%', background: '#B5A78A', padding: '14px', fontSize: '22px', textTransform: 'none', color: 'white', borderRadius: '4px' }}>
          חפש תרגילים
        </a>
        <Typography fontWeight={600} color="#C4A484" mt="20px" mb="50px" ssx={{ opacity: '0.1', display: { lg: '60px', xs: 'block', md: '34px', xl: '60px' }, fontSize: { lg: '80px', xs: '50px' } }}>
          {/* אימונים לחיים */}
        </Typography>
      </Box>
    </Box >

  )
}

export default HeroBanner
///'"/\()*&%$#@!}{<>][:"